import { SuperAdminReducer } from 'ducks/super-client';
import { combineReducers } from 'redux';

import { LicenseDetailsReducer } from './license-details';
import { LicenseSortReducer } from './license-sort';
import { SelectedFiltersReducer } from './selected-filters';
import {
  AllCostCenterInvitesReducer,
  CostCenterInvitesCacheReducer,
  SelectedCostCenterDetails,
  SelectedCostCenterInvitesReducer,
  SelectedLicenseRowsReducer,
  SelectedUserRowsReducer,
} from './selected-rows';
import { SelectedSuffixesReducer } from './selected-suffixes';
import { SuffixSortReducer } from './suffix-sort';
import { ToolsBarReducer } from './tools-bar';

export default combineReducers({
  toolsBar: ToolsBarReducer,
  selectedFilters: SelectedFiltersReducer,
  superClient: SuperAdminReducer,
  sorts: combineReducers({
    licenses: LicenseSortReducer,
    suffixes: SuffixSortReducer,
  }),
  selections: combineReducers({
    licenses: SelectedLicenseRowsReducer,
    users: SelectedUserRowsReducer,
    invites: SelectedCostCenterInvitesReducer,
    costCenter: SelectedCostCenterDetails,
    suffixes: SelectedSuffixesReducer,
    licenseDetails: LicenseDetailsReducer,
  }),
  allCostCenterInvites: AllCostCenterInvitesReducer,
  costCenterInvitesCache: CostCenterInvitesCacheReducer,
});
